import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "expandButton", "collapseButton"]

  connect() {
    // Solo aplicar comportamiento de collapse en móviles
    if (this.isMobile()) {
      this.isExpanded = false
      this.collapse()
    } else {
      // En desktop, asegurarse de que el panel esté visible
      this.panelTarget.classList.remove('max-h-0', 'opacity-0', '-translate-y-4')
      this.panelTarget.classList.add('max-h-[calc(100vh-45px)]', 'opacity-100', 'translate-y-0')
    }
  }

  toggle() {
    // Solo permitir toggle en móviles
    if (!this.isMobile()) return

    if (this.isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    // Feedback háptico
    if (navigator.vibrate) {
      navigator.vibrate(5)
    }

    // Expandir el panel con efecto persiana desde arriba
    this.panelTarget.classList.remove('max-h-0', 'opacity-0', '-translate-y-4')
    this.panelTarget.classList.add('max-h-[calc(100vh-45px)]', 'opacity-100', 'translate-y-0')
    
    // Rotar el ícono chevron hacia arriba
    if (this.hasExpandButtonTarget) {
      const icon = this.expandButtonTarget.querySelector('svg')
      if (icon) {
        icon.classList.add('rotate-180')
      }
    }
    
    this.isExpanded = true
  }

  collapse() {
    // Colapsar el panel con efecto persiana hacia arriba
    this.panelTarget.classList.add('max-h-0', 'opacity-0', '-translate-y-4')
    
    // Restaurar rotación del ícono chevron hacia abajo
    if (this.hasExpandButtonTarget) {
      const icon = this.expandButtonTarget.querySelector('svg')
      if (icon) {
        icon.classList.remove('rotate-180')
      }
    }
    
    this.isExpanded = false
  }

  isMobile() {
    return window.innerWidth < 768
  }
}
